module.exports = __webpack_public_path__ + "media/A1.00406c20.mp3";